import React, { Component } from "react";
import cn from "classnames";
import { FormattedMessage } from "react-intl";

import { aspectRatio as ar } from "../../../../../common/parameters";

import Icon from "../../../../icon";

import Score from "../../../Score/score-display";
import RhythmPanel from "../../../Score/editor/RhythmPanel";
import {
    handleRhythmInput,
    handleRemoveNote,
    handleToggleRest,
    handleDotInput,
    handleTrupletInput,
    handleTie,
    handleSelect,
    keydown,
} from "../../../Score/methods/rhythm";

import Wrapper from "../../Wrapper";

import MessageDisplay from "../Common/MessageDisplay";
import NotEdited from "../Common/NotEdited";
import getScore from "../Common/getScore";
import getScale from "../Common/getScale";
import getBirdsPath from "../Common/getBirdsPath";
import play from "../Common/play";
import setUp from "../Common/setupNotation";
import { INotationThis } from "../Common/interfaces";

import { SubmitButton, PlayBtn, CheckPlayBtn, Label } from "../common-style";

import { ScoreWrapper, RhytLadderWrapper, Asset1Wrapper, Asset2Wrapper, Asset3Wrapper, EasterBackground, ChristmasBackground } from "./styles";
import messages from "./messages";
import { IProps, IState } from "./interfaces";
import { IBar, INote, IScore, IScoreEditorThis } from "../../../../../common/types";

class RhytNotation extends Component<IProps, IState> {
    taskType = "rhytNotation";
    play = play.bind(this as unknown as INotationThis);
    setUp = setUp.bind(this as unknown as INotationThis);
    keydown: (e: KeyboardEvent) => void = () => null;
    score?: IScore = undefined;
    distribution?: number[][];
    scoreRef?: HTMLDivElement;
    firstNoteLength?: INote["l"];
    static defaultProps = {
        handlePlayCount: () => {},
        handleFailCount: () => {},
    };
    constructor(props: IProps) {
        super(props);
        let score = getScore(props.plan, props.task);
        if (score) {
            score = JSON.parse(JSON.stringify(score));
        }
        if (!props.preview && score) {
            if (score.bars[0]) {
                score.bars = [
                    {
                        notes: [],
                    },
                ];
            } else {
                score.bars = [null, { notes: [] }];
            }
            score.settings.upperText = 0;
        } else if (score) {
            score.bars.forEach(bar => {
                if (!bar) return;
                bar.notes.forEach(note => {
                    delete note.p;
                });
            });
        }
        this.state = {
            submitable: false,
            submited: false,
            playing: false,
            completed: false,
            checkPlaying: false,
            notes: [],
            incorrectNotes: [[]],
            score,
            playingNote: [],
            playable: false,
            restMode: false,
            selectedNote: null,
        };
        if (props.setReset) {
            props.setReset(this.resetTask);
        }
        if (props.saveState) {
            props.saveState(this.saveState);
        }
        if (props.restoreState) {
            props.restoreState(this.restoreState);
        }
        if (props.showSolution) {
            props.showSolution(this.showSolution);
        }
        if (!props.preview) {
            this.keydown = keydown.bind(this as unknown as IScoreEditorThis);
        }
    }
    resetTask = () => {
        this.setUp();
        const { plan, task } = this.props;
        this.score = getScore(plan, task);
        const score = JSON.parse(JSON.stringify(this.score));
        if (score.bars[0]) {
            score.bars = [
                {
                    notes: [],
                },
            ];
        } else {
            score.bars = [null, { notes: [] }];
        }
        score.settings.upperText = 0;
        this.setState({
            score,
            submitable: false,
            submited: false,
            completed: false,
        });
    };
    saveState = () => {
        return {
            submited: this.state.submited,
            score: this.state.score,
            incorrectNotes: this.state.incorrectNotes,
            submitable: this.state.submitable,
            completed: this.state.completed,
        };
    };
    restoreState = (state: IState) => {
        this.setState({
            submited: state.submited,
            incorrectNotes: state.incorrectNotes,
            submitable: state.submitable,
            completed: state.completed,
            score: state.score,
        });
    };
    showSolution = () => {
        const score = JSON.parse(JSON.stringify(this.score)) as IScore;
        score.bars.forEach(bar => {
            if (!bar) return;
            bar.notes.forEach(note => {
                delete note.p;
                delete note.y;
                delete note.y2;
                delete note.h;
                delete note.h2;
            });
        });
        this.setState({
            score,
            completed: true,
            submited: true,
        });
    };
    componentDidMount() {
        const { plan, task } = this.props;
        this.score = getScore(plan, task);
        this.setUp();
        window.addEventListener("keydown", this.keydown);
    }

    componentWillUnmount() {
        window.removeEventListener("blur", this.blur);
        if (this.state.playing) {
            this.play();
        }
        window.removeEventListener("keydown", this.keydown);
    }

    blur = () => {
        this.play(true, "rhytNotation");
    };

    getNoteAtPosition3 = (notes: INote[], targetPosition3: number): INote | undefined => {
        let position3 = 0;
        let targetNote;
        notes.forEach((note, noteIndex) => {
            if (targetPosition3 === position3) targetNote = note;
            position3 += (4 / note.l) * (note.d ? 1.5 : 1) * (note.t ? 2 : 3);
        });
        return targetNote;
    };
    submit = () => {
        const incorrectNotes: number[][] = [[]];
        const score = this.state.score!;
        const taskScore = this.score!;
        let completed = true;
        let n = 0;
        let position3 = 0;
        if (Math.abs(score.bars.length - taskScore.bars.length) > 1) completed = false;
        score.bars.forEach((bar, barIndex) => {
            if (!bar) return;
            position3 = 0;
            if (taskScore.bars[barIndex] === undefined) {
                completed = false;
            } else if ((taskScore.bars as IBar[])[barIndex].notes.length !== bar.notes.length) {
                completed = false;
            }
            bar.notes.forEach((note, noteIndex) => {
                if (!taskScore.bars[barIndex]) {
                    incorrectNotes[0].push(n);
                    return;
                }
                const solutionNote = this.getNoteAtPosition3((taskScore.bars as IBar[])[barIndex].notes, position3);
                if (!solutionNote) {
                    incorrectNotes[0].push(n);
                } else if (solutionNote.l !== note.l || solutionNote.d !== note.d || solutionNote.r !== note.r) {
                    incorrectNotes[0].push(n);
                }
                n++;
                position3 += (4 / note.l) * (note.d ? 1.5 : 1) * (note.t ? 2 : 3);
            });
        });
        if (incorrectNotes[0].length > 0) completed = false;
        if (completed) {
            window.removeEventListener("keydown", this.keydown);
            if (this.props.completed) {
                this.props.completed("rhytNotation");
            }
        } else {
            this.props.handleFailCount!();
        }

        this.setState({ incorrectNotes, submited: true, completed });
    };

    tryAgain = () => {
        this.setState({
            submitable: false,
            submited: false,
            incorrectNotes: [[]],
        });
    };

    setRef = (ref: HTMLDivElement) => {
        this.scoreRef = ref;
    };
    setDistribution = (distribution: number[][]) => {
        this.distribution = distribution;
    };

    render() {
        const {
            incorrectNotes,
            submited,
            playable,
            playing,
            completed,
            checkPlaying,
            score,
            selectedNote,
            restMode,
            playingNote,
        } = this.state;
        const { task, isLow, isDemo, plan, handleHomeworkNext, isEaster, isChristmas } = this.props;
        const { data } = task;
        if (!data || !playable || !this.score)
            return (
                <div>
                    <div>
                        <Wrapper>
                            <NotEdited />
                        </Wrapper>
                    </div>
                </div>
            );
        return (
            <div>
                <Wrapper isDemo={isDemo}>
                    {isLow && (
                        <>
                            <Asset1Wrapper>
                                <img src={getBirdsPath("/rhytNotation/asset-01.svg")} alt="decoration" />
                            </Asset1Wrapper>
                            <Asset2Wrapper>
                                <img src={getBirdsPath("/rhytNotation/asset-02.svg")} alt="decoration" />
                            </Asset2Wrapper>
                            <Asset3Wrapper>
                                <img src={getBirdsPath("/rhytNotation/asset-03.svg")} alt="decoration" />
                            </Asset3Wrapper>
                        </>
                    )}
                    {isEaster && (
                        <EasterBackground />
                    )}
                    {isChristmas && (
                        <ChristmasBackground />
                    )}
                    <ScoreWrapper isLow={!!isLow} isEaster={isEaster || isChristmas}>
                        <Score
                            score={score!}
                            scale={getScale(plan, task) * (isLow ? 0.5425 : (isEaster || isChristmas) ? (1076 / ar.width) : 1)}
                            incorrectNotes={incorrectNotes}
                            whiteBackground={isLow}
                            selectNote={handleSelect.bind(this as unknown as IScoreEditorThis)}
                            selectedNote={selectedNote}
                            setRef={this.setRef}
                            activeVoice={0}
                            playing={playing}
                            playingNote={playingNote}
                            checkPlaying={checkPlaying}
                            rhytNotation
                            setDistribution={this.setDistribution}
                            isEaster={isEaster || isChristmas}
                        />
                    </ScoreWrapper>
                    {(!submited || completed) && (
                        <RhytLadderWrapper isLow={!!isLow} className={cn(completed && "Completed")}>
                            <RhythmPanel
                                hint={data.hint && score!.bars.filter(bar => bar && bar.notes.length !== 0).length === 0 ? this.firstNoteLength : undefined}
                                handleRhythmInput={handleRhythmInput.bind(this as unknown as IScoreEditorThis)}
                                handleDotInput={handleDotInput.bind(this as unknown as IScoreEditorThis)}
                                handleRemoveNote={e => handleRemoveNote.call(this as unknown as IScoreEditorThis, e, true)}
                                handleToggleRest={handleToggleRest.bind(this as unknown as IScoreEditorThis)}
                                handleTrupletInput={handleTrupletInput.bind(this as unknown as IScoreEditorThis)}
                                score={score!}
                                taskScore={this.score}
                                restMode={restMode}
                                selectedNote={selectedNote}
                                handleTieNote={handleTie.bind(this as unknown as IScoreEditorThis)}
                                activeVoice={0}
                                playing={false}
                                editor={false}
                            />
                        </RhytLadderWrapper>
                    )}
                    <PlayBtn
                        className={cn("button", "button--play")}
                        isEaster={isEaster}
                        onClick={() => this.play(true, "rhytNotation", undefined, false, data.rhytPlayStyle || "auto")}
                        disabled={checkPlaying}
                        isLow={isLow}
                    >
                        {playing ? <Icon i="stop" /> : <Icon i="play" />}
                        <Label>
                            <FormattedMessage {...messages.play} />
                        </Label>
                    </PlayBtn>
                    <CheckPlayBtn
                        className={cn("button", "button--check")}
                        isEaster={isEaster}
                        onClick={() => this.play(false, "rhytNotation", undefined, true, data.rhytPlayStyle || "auto")}
                        disabled={playing && !checkPlaying}
                        isLow={isLow}
                    >
                        {checkPlaying ? <Icon i="stop" /> : <Icon i="play" />}
                        <Label>
                            <FormattedMessage {...messages.check} />
                        </Label>
                    </CheckPlayBtn>
                    {submited && !completed && (
                        <SubmitButton
                            isLow={isLow}
                            isEaster={isEaster}
                            style={{ bottom: isLow ? 185 : isEaster ? 30 : 3 }}
                            className={cn("button")}
                            onClick={() => {
                                this.tryAgain();
                            }}
                        >
                            <FormattedMessage {...messages.tryAgain} />
                        </SubmitButton>
                    )}
                    {!completed && !submited && (
                        <SubmitButton
                            isLow={isLow}
                            isEaster={isEaster}
                            style={{
                                top: isLow ? 30 : 6,
                                bottom: "auto",
                                right: 540,
                                left: "auto",
                                paddingBottom: 5,
                                paddingTop: 5,
                            }}
                            className={cn("button")}
                            onClick={() => {
                                this.submit();
                            }}
                        >
                            <FormattedMessage {...messages.submit} />
                        </SubmitButton>
                    )}
                    {completed && (
                        <MessageDisplay isChristmas={isChristmas} isLow={!!isLow} type="completed" handleHomeworkNext={handleHomeworkNext} />
                    )}
                    {submited && !completed && <MessageDisplay isChristmas={isChristmas} isLow={!!isLow} type="incorrect" />}
                </Wrapper>
            </div>
        );
    }
}

export default RhytNotation;
